export enum NavigationMenuConstants {
  width = 230,
}
